import React from 'react';
import styled from 'styled-components';
import { Spin } from 'antd';
import Head from 'next/head';
import NProgress from 'nprogress';
import { Spinner } from 'components/Spinner';
import { withRouter } from 'next/router';
import { Router } from '../routes';
import { breakpoint } from '../styles/breakpoint';
import { imagePaths } from '../components/commonImageUrls';
import { colour } from '@a-cloud-guru/themes';

NProgress.configure({ parent: 'body', showSpinner: false });

Router.onRouteChangeStart = () => {
  NProgress.start();
};
Router.onRouteChangeComplete = () => {
  NProgress.done();
};
Router.onRouteChangeError = () => {
  NProgress.done();
};

Spin.setDefaultIndicator(<Spinner />);

const getCustomProps = isLA => ({
  href: 'https://acloudguru.com',
  height: 35,
  width: 200,
  img: imagePaths.logoDesktop(isLA),
  alt: 'A Cloud Guru logo',
  backgroundColor: colour.navy700,
  ...(isLA && {
    height: 33,
    width: 93,
    alt: 'A Cloud Guru and Linux Academy logos',
    backgroundColor: colour.navy900
  })
});

class MainLayout extends React.PureComponent {
  render() {
    const { width, height, alt, backgroundColor, img, href } = getCustomProps(this.props.isLA);
    return (
      <Layout backgroundColor={backgroundColor}>
        <Head>
          <meta name="theme-color" content={backgroundColor} />
        </Head>
        <Container style={{ display: 'none' }}>
          <Header>
            <Logo href={href}>
              <img src={img} alt={alt} width={width} height={height} />
            </Logo>
          </Header>
          <PageBody>{this.props.children}</PageBody>
        </Container>
      </Layout>
    );
  }
}

const Layout = styled.div`
  background-color: ${({ backgroundColor }) => backgroundColor};
  font-size: 16px;
  position: relative;
`;

const Container = styled.div`
  min-height: 100vh;
  max-width: 1500px;
  display: flex !important;
  flex-direction: column;
  flex: auto;
  color: #fff;
  margin: 0 auto;
`;

const PageBody = styled.div`
  padding: 40px 20px 22px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  @media ${breakpoint.medium} {
    padding-left: 60px;
    padding-right: 60px;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 2.25em;
  padding-top: 2em;

  @media ${breakpoint.small} {
    font-size: 82%;
  }

  @media ${breakpoint.medium} {
    flex-direction: row;
  }

  @media ${breakpoint.large} {
    font-size: 100%;
  }
`;

const Logo = styled.a`
  cursor: pointer;

  img {
    max-width: 100%;
  }
`;

export default withRouter(MainLayout);
